import { BottomDrawerModal } from "@/components/shared/bottom-drawer-modal";
import { UserList } from "@/components/shared/icons";
import { Button, Image, View } from "@/components/ui";

import { ListHeading } from "../list-header";
import { Typography } from "../typography";

export function CaregiverPortfolio({
  openModal,
  onClose,
  cleanerProfilePhoto,
  workerName,
  description,
}: {
  openModal: boolean;
  onClose: () => void;
  cleanerProfilePhoto: string;
  workerName: string;
  description: string | null | undefined;
}) {
  const handleClose = (isOpen: boolean) => {
    if (!isOpen) {
      onClose();
    }
  };

  return (
    <BottomDrawerModal open={openModal} onOpenChange={handleClose}>
      <ListHeading title="Care giver Profile" icon={UserList} />
      <View className="mt-4 flex flex-col">
        <View className="border-secondary-border mb-3 flex flex-row gap-4 border-b pb-3">
          <View className="h-[186px] w-full max-w-[134px] overflow-hidden rounded-xl">
            <Image
              src={cleanerProfilePhoto}
              width={134}
              height={186}
              className="h-[186px] w-[134px] rounded-xl object-cover"
            />
          </View>
          <View className="flex flex-col gap-2">
            <Typography variant="label-sm">{workerName}</Typography>
            <View className="max-w-[220px]">
              <Typography variant="body-sm" color="foreground-intermediate">
                {description}
              </Typography>
            </View>
          </View>
        </View>
        <Button variant="primary" color="CTA" children="OK" onClick={() => onClose()} />
      </View>
    </BottomDrawerModal>
  );
}
